<template>
  <div class="addware">
    <!--<above-nav></above-nav>-->
    <div class="content-wrapper">
      <div class="content">
        <div class="back" @click="goBack">< 返回上一页</div>
        <div class="info-wrapper">
          <h2 class="title">{{scheduleinfo.catalog_index}}课
            {{decodeURIComponent(scheduleinfo.catalogname)}}
          </h2>
          <p class="row">课程：《{{decodeURIComponent(scheduleinfo.lessonname)}}》</p>
          <p class="row">
            班级：{{decodeURIComponent(scheduleinfo.classmodename)}}-{{decodeURIComponent(scheduleinfo.classname)}}</p>
          <p class="row">
            上课时间：{{scheduleinfo.planstarttime.substring(11, 16)}}-{{scheduleinfo.planendtime.substring(11, 16)}}</p>
          <button class="add" @click="showAddSchedule">添加课件</button>
          <table class="table">
            <tr class="first">
              <th style="width: 230px;">课件封面</th>
              <th style="width: 230px;">课件名称</th>
              <th style="width: 400px;">课件介绍</th>
              <th style="width: 146px;">操作</th>
            </tr>
            <tr v-for="(item,index) in classWareList" class="tr">
              <td style="vertical-align: middle">
                <img :src="computeUrl(item.faceimg)" alt="cover" width="180" height="120">
              </td>
              <td style="font-size:16px;color:#000;vertical-align: middle">
                {{decodeURIComponent(item.coursewarename)}}
              </td>
              <td style="font-size:14px;color:#333;vertical-align: middle">
                {{decodeURIComponent(item.introduce)}}
              </td>
              <td style="font-size:14px;color:#3399ff;vertical-align: middle;cursor: pointer"
                  @click="del(item,index)">
                删除
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="warePop" v-if="warePopShow">
      <div class="ware-content-wrapper">
        <h3 class="ware-title">选择课件</h3>
        <div class="flex-wrapper">
          <p class="left">已选择：{{count}}个</p>
          <p class="right" @click="gotoMake">制作新课件</p>
        </div>
        <div class="ware-wrapper">
          <template v-for="(item,index) in lessonWareList">
            <div class="classware">
              <img class="cover" :src="computeUrl(item.faceimg)" alt="cover" width="80" height="60">
              <div class="classware-middle">
                <h3 class="title">{{decodeURIComponent(item.coursewarename)}}</h3>
                <p class="introduce">{{decodeURIComponent(item.introduce)}}</p>
              </div>
              <img v-if="item.show===false"
                   @click="show(item,index)"
                   class="del"
                   src="./beforeSelect.png"
                   alt="delete-button" width="20"
                   height="20">
              <img v-if="item.show===true"
                   @click="item.show=false;count--"
                   class="del"
                   src="./selected.png"
                   alt="delete-button" width="20"
                   height="20">
            </div>
          </template>
        </div>
        <div class="ware-btn-outside">
          <div class="ware-btn-inside">
            <button class="cancel" @click="warePopShow=false;">取消</button>
            <button class="confirm" @click="addWare">确定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import topNav from 'components/topnav/TopNav';
  import Vue from 'vue';
  import aboveNav from 'components/abovenav/AboveNav'
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        lessoninfo: (() => loadLocal('lessoninfo', false))(),
        scheduleinfo: (() => loadLocal('scheduleinfo', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        //-------------------以下内容和课件有关----------------------//
        classWareList: [],
        lessonWareList: [],
        count: 0,
        warePopShow: false,
      }
    },
    methods: {
      goBack(){
        this.$router.replace('/console/lesson/schedule');
      },
      gotoMake(){
        this.$router.push('/console/lesson/ware')
      },
      computeUrl(url){
        if (url === '') {
          return require('./cover.png');
        } else {
          return this.imgprefix + url;
        }
      },
      //获取当前目录的课件列表
      queryClassCourseWare(){
        //接口：查询课件在课程目录中的列表内容
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassCourseWare',
            a: 'QueryClassCourseWare',
            id: this.id,
            classcatalogid: this.scheduleinfo.id,
            pageno: 1,
            pagesize: 200,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          this.classWareList = response.list;
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //删除课件
      del(item, index){
        //接口：删除在课程目录中的指定课件
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassCourseWare',
            a: 'DeleteClassCourseWare',
            id: this.id,
            rid: this.schoolNow.rid,
            lessonid: item.lessonid,
            classid: item.classid,
            coursewareid: item.coursewareid,
            classcatalogid: item.classcatalogid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.classWareList.splice(index, 1);
            this.$message({
              message: '删除成功',
              type: 'success'
            })
          }
        }).catch((err) => {
          this.$alert('请求失败，请重试', '提示', {
            confirmButtonText: '确定',
          });
        });
        this.$forceUpdate()  // 迫使 Vue 实例重新渲染。}
      },
      //点击添加课件
      showAddSchedule(){
        this.count = 0;
        if (this.lessonWareList != null) {
          this.lessonWareList.forEach(function (ele) {
            ele.show = false;
          })
        }
        this.warePopShow = true;
        this.QueryCourseWares();
      },
      show(item, index){
        Vue.set(this.lessonWareList[index], 'show', true);
        this.count++;
        this.$forceUpdate();
      },
      //获取课程的课件列表
      QueryCourseWares(){
        //接口：查询课程的课件列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'CourseWare',
            a: 'QueryCourseWares',
            id: this.id,
            queryrid: this.schoolNow.rid,
            lessonid: this.lessoninfo.id,
            pageno: 1,
            pagesize: 300,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          this.lessonWareList = response.list;
          if (this.lessonWareList != null) {
            this.lessonWareList.forEach(function (ele) {
              ele.show = false;
            })
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //勾选完课件后，选择确定
      addWare(){
        if (this.lessonWareList == null) {
          this.warePopShow = false;
          return;
        }
        let list = [];
        //根据lessonWareList中每个项的show是否为true，将其添加到list中
        for (let i = 0; i < this.lessonWareList.length; i++) {
          if (this.lessonWareList[i].show === true) {
            list.push(this.lessonWareList[i]);
          }
        }
        if (list.length === 0) {
          this.$message({
            message: '请选择相应的课件',
            type: 'waring',
          })
        } else {
          const loading = this.$loading({
            lock: true,
            text: '添加中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          let count = 0;
          for (let i = 0; i < list.length; i++) {
            //接口：添加课件到对应的课程目录
            this.$http({
              url: '/indexapp.php',
              method: 'GET',
              params: {
                c: 'ClassCourseWare',
                a: 'AddClassCourseWare',
                id: this.id,
                rid: this.schoolNow.rid,
                lessonid: this.lessoninfo.id,
                classid: this.scheduleinfo.classid,
                coursewareid: list[i].sceneid,
                classcatalogid: this.scheduleinfo.id,
                coursewarename: list[i].coursewarename,
              }
            }).then((response) => {
              response = response.data;
              if (response.code === 111) {
                this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
              }
              if (response.code === 200 || response.code === 102) {
                count++;
                if (count === list.length) {
                  loading.close();
                  this.$message({
                    message: '添加成功',
                    type: 'success'
                  });
                  this.queryClassCourseWare();
                  this.warePopShow = false;
                }
              }
            }).catch((err) => {
              loading.close();
              this.$alert('未获取到数据，请重新加载页面', '提示', {
                confirmButtonText: '刷新',
                callback: action => {
                  window.location.reload();
                }
              });
            });
          }
        }
      },
    },
    created(){
      this.queryClassCourseWare();
    },
    components: {
      topNav,
      aboveNav
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .addware
    position fixed
    left: 160px
    top: 91px
    right: 0
    bottom: 0
    background #f2f2f2
    overflow auto
    .content-wrapper
      padding: 20px 0 20px
      min-width: 1206px
      font-size: 0
      overflow auto
      .content
        margin-left: 20px
        padding-bottom: 20px
        width: 1166px
        background #fff
        .back
          padding: 15px 0 0 10px
          line-height: 24px
          font-size: 15px
          color: #888888
          cursor pointer
        .info-wrapper
          padding: 50px 0 20px 80px
          .title
            font-size: 24px
            color: #000000
            font-weight: bold
            line-height: 32px
            margin-bottom: 35px
          .row
            font-size: 14px
            color: #888888
            line-height: 19px
            margin-bottom: 10px
          .add
            display: inline-block
            margin: 25px 0 20px 0
            width: 85px
            height: 34px
            line-height: 34px
            color: #ffffff
            background #3399ff
            text-align: center
            font-size: 16px
            border-radius 4px

          .table
            width: 1006px
            border: 1px solid #d7d7d7
            table-layout: fixed
            .first
              height: 40px
              th
                font-size: 14px
                color: #555
                line-height: 40px
                width: 143px
                border: 1px solid #d7d7d7
                box-sizing: border-box

            .tr
              height: 160px
              text-align: center
              border: 1px solid #d7d7d7
              td
                border: 1px solid #d7d7d7

    .warePop
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      overflow: auto
      .ware-content-wrapper
        margin: auto
        width: 720px
        padding: 30px 60px 40px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .ware-title
          font-size: 24px
          color: #000000
          font-weight: bold
          line-height: 40px
        .flex-wrapper
          margin: 25px 0 8px 0
          display: flex
          justify-content space-between
          .left
            font-size: 14px
            color: #000000
            line-height: 19px
          .right
            cursor: pointer
            font-size: 14px
            color: #3399ff
            line-height: 19px
        .ware-wrapper
          width: 600px
          height: 450px
          padding: 20px
          border: 1px solid #e4e4e4
          box-sizing border-box
          overflow auto
          .classware
            padding: 10px 0
            border-bottom: 1px solid #e4e4e4
            .cover
              vertical-align top
            .classware-middle
              display: inline-block
              margin-left: 10px
              vertical-align top
              .title
                font-size: 14px
                color: #000000
                line-height: 22px
              .introduce
                margin-top: 12px
                width: 400px
                height: 26px
                font-size: 12px
                color: #999999
                line-height: 13px
                overflow hidden
            .del
              position relative
              top: 20px
              margin-left: 20px
              cursor pointer

        .ware-btn-outside
          margin-top: 40px
          height: 34px
          .ware-btn-inside
            margin: 0 auto
            width: 225px
            .cancel, .confirm
              width: 80px
              height: 34px
              line-height: 34px
              text-align: center
              font-size: 16px
              color: #ffffff
              border-radius 4px
              box-sizing border-box
            .cancel
              margin-right: 65px
              background #ccc
            .confirm
              background #3399ff

</style>



// WEBPACK FOOTER //
// src/page/lesson/lessonschedule/addware/AddWare.vue